import { getSeasonalPromo } from "../lib/seasonalPromo";

export default function PromoBanner() {
  const promo = getSeasonalPromo();

  if (!promo) return null;

  return (
    <section className="promo-banner" aria-label="Seasonal promotion">
      <div className="container promo-banner-inner">
        <div className="promo-banner-copy">
          <p className="promo-kicker">Seasonal Reminder</p>
          <h2 className="promo-title">{promo.title}</h2>
          <p className="promo-body">{promo.body}</p>
        </div>
      </div>
    </section>
  );
}
